import { AsyncPipe, CurrencyPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { Component, DestroyRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { SepaFacade, ServedByOptionType } from '@zero/self-service/domain';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { TradingSessionComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { filter, firstValueFrom } from 'rxjs';
import { SavingsPlanConfirmAssetsComponent } from './savings-plan-confirm-assets/savings-plan-confirm-assets.component';
import { SavingsPlanConfirmConfigItemsComponent } from './savings-plan-confirm-config-items/savings-plan-confirm-config-items.component';
import { SavingsPlanErrorsComponent } from './savings-plan-errors/savings-plan-errors.component';
import { SavingsPlanServedByModalComponent } from './savings-plan-served-by-modal/savings-plan-served-by-modal.component';

@Component({
  selector: 'saving-plans-confirm',
  imports: [
    TranslocoPipe,
    AsyncPipe,
    DatePipe,
    CurrencyPipe,
    TradingSessionComponent,
    SavingsPlanConfirmAssetsComponent,
    LoadingIndicatorDirective,
    SavingsPlanConfirmConfigItemsComponent,
    SavingsPlanErrorsComponent,
    ButtonComponent,
    UpperCasePipe,
    IconComponent,
  ],
  templateUrl: './savings-plan-confirm.component.html',
})
export class SavingsPlanConfirmComponent implements OnInit {
  @Output() public goBack = new EventEmitter<void>();
  @Output() public confirm = new EventEmitter<void>();

  public hasTradingSession = false;

  public readonly facade = inject(SavingsPlanFacade);
  public readonly sepaFacade = inject(SepaFacade);
  public readonly modal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.sepaFacade.loadHasSepa();
    this.sepaFacade.errorMessage$
      .pipe(
        filter((error) => !!error),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.sepaFacade.resetOptions());
  }

  public async handleServedByChange(): Promise<void> {
    const type = await firstValueFrom(this.sepaFacade.selectedOption$);
    const newType = type?.value === ServedByOptionType.Sepa ? ServedByOptionType.Account : ServedByOptionType.Sepa;
    this.sepaFacade.changeOption(newType);
    const ref = this.modal.open(SavingsPlanServedByModalComponent, { size: 'lg', centered: true });
    ref.componentInstance.type = newType;

    const output = await ref.result;
    if (output === 'cancel') {
      this.sepaFacade.resetOptions();
    } else {
      this.sepaFacade.toggleSepa(newType === 'Sepa');
    }
  }
}
